import React, { FC } from 'react';
import { formatDateRuShort, formatDayMonth } from 'utils/date';

import { ReactComponent as Checkbox } from './img/checkbox.svg';
import { ReactComponent as IconDone } from './img/iconDone.svg';
import { ReactComponent as IconAlert } from './img/iconAlertOutline.svg';
import { ReactComponent as IconTime } from './img/iconTime.svg';
import { ReactComponent as IconClose } from './img/iconClose.svg';
import { ReactComponent as IconDraft } from './img/iconDraft.svg';

import styles from './CustomerOrderItem.module.scss';
import { InfoEmployeds } from 'components/InfoEmployeds';
import { FormatAmount } from 'ui/FormatAmount';
import classNames from 'classnames';
import { TextWithTooltip } from 'hooks/TextWithTooltip';
import { AppTooltip } from 'ui/AppTooltip';

interface CustomerOrderItemTypes {
  order: any;
  withCheckbox?: boolean;
  selected: boolean;
  toggleSelect: (id: string) => void;
  lastFnsReceipt?: boolean;
}

export const objIcons: any = {
  moderation_in_progress: IconTime,
  moderation_failed: IconClose,
  worker_invited_by_customer: IconAlert,
  worker_approved_by_customer: IconAlert,
  worker_approved_order: IconTime,
  worker_set_volume: IconTime,
  customer_set_volume: IconTime,
  worker_finished_order: IconAlert,
  work_success: IconAlert,
  act_signed_by_worker: IconAlert,
  payment_in_progress: IconTime,
  act_signed_by_customer: IconTime,
  payment_failed: IconClose,
  payment_returned: IconClose,
  payment_success: IconDone,
  order_canceled: IconClose,
  order_draft: IconDraft,
  order_published: IconTime,
  worker_rejected_by_customer: IconTime,
  order_canceled_by_platform: IconClose,
};

export const objTextColor: any = {
  moderation_in_progress: '#000000',
  moderation_failed: '#E10D0D',
  worker_invited_by_customer: '#F89500',
  worker_approved_by_customer: '#F89500',
  worker_approved_order: '#F89500',
  worker_set_volume: '#F89500',
  customer_set_volume: '#F89500',
  worker_finished_order: '#F89500',
  work_success: '#F89500',
  act_signed_by_worker: '#F89500',
  payment_in_progress: '#121922',
  act_signed_by_customer: '#121922',
  payment_failed: '#E10D0D',
  payment_returned: '#E10D0D',
  payment_success: '#28A879',
  order_canceled: '#000000',
  order_draft: '#71869D',
  order_published: '#121922',
  worker_rejected_by_customer: '#121922',
  order_canceled_by_platform: '#000000',
};

export const CustomerOrderItem: FC<CustomerOrderItemTypes> = ({
  order,
  withCheckbox = false,
  selected,
  toggleSelect,
}) => {
  return (
    <div style={{ width: '100%' }}>
      <div
        className={classNames(
          styles.root,
          withCheckbox && styles.withCheckbox,
          selected && styles.selected,
        )}>
        {withCheckbox && (
          <div
            className={classNames(styles.root_checkbox, selected && styles.with_checkbox)}
            onClick={(e) => {
              e.preventDefault();
              toggleSelect(order.id);
            }}>
            {selected ? (
              <div className={styles.checkbox_active}>
                <Checkbox />
              </div>
            ) : (
              <div className={styles.checkbox}></div>
            )}
          </div>
        )}

        <TextWithTooltip
          content={order?.number ? String(order.number) : ''}
          className={styles.root_item__standart}
        />
        <div
          className={classNames(styles.root_item, styles.root_item__standart)}
          style={{ position: 'relative' }}>
          <TooltipDate date={order?.created_at} />
        </div>
        <div className={styles.root_item}>
          <TextWithTooltip
            content={order.order_type || ''}
            className={styles.root_item__standart}
          />
        </div>
        <div className={styles.root_item} style={{ padding: '8px 14px' }}>
          {order.worker ? (
            <InfoEmployeds
              status={order.worker?.app_status}
              avatar={order.worker?.avatar}
              id={order.worker.id}
              name={order.worker.name}
              surname={order.worker.surname}
              patronymic={order.worker.patronymic}
              isDeleted={order.worker.is_deleted}
            />
          ) : null}
        </div>
        <FormatAmount amount={order?.amount} />
        <div
          className={styles.root_item}
          style={{
            display: 'flex',
            width: '100%',
            minWidth: 0,
          }}>
          <Status
            title={order.status?.text}
            color={order.status.color_bg || objTextColor[order.status?.value] || '#000'}
            Icon={
              order.status?.text === 'Требуется выбрать исполнителя'
                ? IconAlert
                : objIcons[order.status?.value] || null
            }
          />
        </div>
        <div
          className={classNames(styles.root_item, styles.root_item__standart)}
          style={{ position: 'relative' }}>
          {order?.worker_payment_date ? (
            <TooltipDate date={order?.worker_payment_date} />
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
};

export const Status = ({
  title,
  color,
  Icon = null,
}: {
  title: string;
  color: string;
  Icon?: any;
  styleUnreadOrder?: boolean;
}) => {
  return (
    <div className={styles.status}>
      <div
        className={Icon ? styles.status_icon : styles.status_circle}
        style={Icon ? {} : { backgroundColor: color }}>
        {Icon && <Icon style={{ color }} />}
      </div>
      <div className={styles.status_title}>
        <TextWithTooltip content={title} style={{ color }} />
      </div>
    </div>
  );
};

export const TooltipDate = ({ date }: { date: string }) => {
  return (
    <AppTooltip label={formatDateRuShort(date)}>
      <div>{formatDayMonth(date)}</div>
    </AppTooltip>
  );
};
